import React                from 'react';
import classNames           from 'classnames';
import { Observe }          from 'rewire-core';
import {
  WithStyle,
  ActionType,
  DefaultActionRenderer,
}                           from 'rewire-ui';
import Divider              from '@material-ui/core/Divider';
import { Theme }            from '@material-ui/core/styles';
import { InfoPanelContext } from './InfoPanel';
import { withStyles }       from '../utility/styles';

const styles = (theme: Theme) => ({
  infoPanelFooterActionButtonRoot: {
    textTransform: 'uppercase',
    marginRight: '10px',
    width: '100%',
    '&:last-child': {
      marginRight: '0px',
    },
  },
  infoPanelFooterActionButtonButton: {
    width: '100%',
    height: '100%',
  },
  infoPanelFooterPrimaryActionButtonButton: {
    backgroundColor: theme.palette.dialogPrimary.main,
    color: theme.palette.dialogPrimary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.dialogPrimary.light,
    },
  },
  infoPanelFooterContainer: {
    margin: 'auto 0 0 0',
  },
  infoPanelFooterContainerMinimized: {
    display: 'none',
  },
  infoPanelFooterControls: {
    flexShrink: 0,
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    padding: '10px',
  },
  infoPanelFooterActionIcon: {
    marginRight: '8px',
  },
});

export interface IInfoPanelFooterProps {
  isDisabled: boolean;
  actions?:   {[index: string]: ActionType};
  classes?:   any;
}

export type InfoPanelFooterProps = WithStyle<ReturnType<typeof styles>, IInfoPanelFooterProps>;

class InfoPanelFooter extends React.Component<InfoPanelFooterProps> {
  constructor(props: InfoPanelFooterProps) {
    super(props);
  }

  render() {
    return (
      <InfoPanelContext.Consumer>
        {({isOpenInfoPanel}) => (
          <Observe render={() => {
            const {classes, isDisabled, actions} = this.props;

            return (
              <div className={classNames(classes.infoPanelFooterContainer, !isOpenInfoPanel ? classes.infoPanelFooterContainerMinimized : '')}>
                <Divider />
                <div className={classes.infoPanelFooterControls}>
                  {actions && Object.keys(actions).map((actionName: string) => {
                    const action = actions[actionName];
                    return (
                      <DefaultActionRenderer key={actionName} label={actionName} action={action} isDisabled={isDisabled} variant='contained' classes={{root: classes.infoPanelFooterActionButtonRoot, button: classNames(classes.infoPanelFooterActionButtonButton, action.type === 'submit' ? classes.infoPanelFooterPrimaryActionButtonButton : undefined), icon: classes.infoPanelFooterActionIcon}} />
                    );
                  }
                  )}
                </div>
              </div>
            );
          }} />
        )}
      </InfoPanelContext.Consumer>
    );
  }
}

export default withStyles<IInfoPanelFooterProps>(styles, InfoPanelFooter);
